import React, { useState, useEffect, useRef } from 'react';

import { Link } from 'react-router-dom';
// import Slider, { Range } from 'rc-slider';
import { TextField } from '@material-ui/core';
import './Eyesighttestslider.css';
import a1 from '../../assets/images/a1.png';
import a2 from '../../assets/images/a2.png';
import a3 from '../../assets/images/a3.png';
import a4 from '../../assets/images/a4.png';
import a5 from '../../assets/images/a5.png';
import a6 from '../../assets/images/a6.png';
import s1 from '../../assets/images/eyetest.png';
import s2 from '../../assets/images/visual-acuitytest.png';
import s3 from '../../assets/images/astigmatism-test.png';
import s4 from '../../assets/images/corneal-test.png';
import Slider from 'react-slick';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';

function EyeSightTestSlider() {
    var settings = {
        dots: true,
        infinite: true,
        speed: 500,
        slidesToShow: 3,
        slidesToScroll: 1
    };
    // function setImg(){
    //     return slider_img.setAttribute('src', '../../assets/tracker-assets/' +images[i]);
    // }

    return (

        <div>
            <Slider {...settings} >
                <img src={s1}  />
               <img src={s2} />
                <img src={s3} />
                <img src={s4} />
            </Slider>
        </div>
    );
};

export default EyeSightTestSlider;
